<template>
  <div class="content animate-panel" id="page-warehouses">
    <h2 class="m-n box-warehouse-title">
      <div class="warehouse-image">
        <img src="/static/dists/img/warehouse.png" alt="" class="img-responsive">
      </div>
      <div class="warehouse-title">倉庫管理</div>
    </h2>
    <div class="box-overview">
      <div class="box-warehouse-sale">
        <div class="warehouse-sale-title">倉庫を活用して物販を効率化</div>
        <div class="warehouse-sale-content">
          セールモンスターではセラー様が管理する倉庫、セールモンスターが管理する倉庫を利用することができます。<br>
          倉庫を活用して出荷作業を効率化することができます。
        </div>
      </div>
      <div v-if="usingLogiSettings.length" class="box-warehouse-using">
        <div class="warehouse-using-title">利用中の倉庫</div>
        <div v-for="usingLogiSetting in usingLogiSettings" :key="`usingLogiSetting-${usingLogiSetting.seq}`" class="warehouse-using-item">
          <div class="row">
            <div class="col-md-8 left-item">
              <div class="warehouse-item-header">
                <div class="left-item-header-one">
                  <img class="img-responive logi-icon" :src="usingLogiSetting.iconUrl" alt="">
                </div>
                <div class="left-item-header-two">
                  <p :class="`logi-kbn m-b-none ${usingLogiSetting.logiKbnItem.class}`">{{ usingLogiSetting.logiKbnItem.name }}</p>
                  <div>
                    <span class="logi-name m-b-none">{{ usingLogiSetting.logiName }}</span>
                    <template v-if="usingLogiSetting.systemName === 'Amazon'">
                      <span v-if="parseInt(usingLogiSetting.requiredFlg)" class="required-flg">必須</span>
                    </template>
                    <template v-if="usingLogiSetting.systemName === 'salmonAcross'">
                      <span :class="`usage-status ${usingLogiSetting.usageStatusItem.class}`">{{ usingLogiSetting.usageStatusItem.status }}</span>
                    </template>
                  </div>
                </div>
              </div>
              <div class="warehouse-item-content">
                <div class="left-item-content">
                  <template>
                    <button type="button" class="btn btn-warning w-150 button-to-warehouse-link mr-b-10" @click.prevent="openWarehouseManagement(usingLogiSetting)">倉庫管理を開く</button>
                  </template>
                </div>
                <div class="right-item-content">
                  <div class="logi-sumary" v-html="replaceHTMLSellerInfo(usingLogiSetting.summary)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!initial" class="box-additional-warehouse">
        <div class="warehouse-using-title">
          <img class="img-reponsive additional-circle" src="/static/dists/img/additional_circle.svg" alt=""/>
          <div class="warehouse-using-title-text">追加可能な倉庫</div>
        </div>
        <template v-if="additionalLogiSettings.length">
          <div v-for="additionalLogiSetting in additionalLogiSettings" :key="`additionalLogiSetting-${additionalLogiSetting.seq}`" class="warehouse-additional-item">
            <div class="row">
              <div class="col-md-9 left-item">
                <div class="warehouse-item-header">
                  <div class="left-item-header-one">
                    <img class="logi-icon img-responsive" :src="additionalLogiSetting.iconUrl" alt="">
                  </div>
                  <div class="left-item-header-two">
                    <p :class="`logi-kbn m-b-none ${additionalLogiSetting.logiKbnItem.class}`">{{ additionalLogiSetting.logiKbnItem.name }}</p>
                    <div>
                      <span class="logi-name">{{ additionalLogiSetting.logiName }}</span>
                      <span v-if="!additionalLogiSetting.usageStatusItem.status && parseInt(additionalLogiSetting.recommendFlg) && additionalLogiSetting.systemName !== 'salmonAcross'" class="recommend-flg">おすすめ</span>
                      <span v-if="additionalLogiSetting.usageStatusItem.status" :class="`usage-status ${additionalLogiSetting.usageStatusItem.class}`">{{ additionalLogiSetting.usageStatusItem.status }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="additionalLogiSetting.systemName === 'salmonYamato'" class="warehouse-item-content">
                  <p class="text-size-20 font-bold text-danger">本サービスは、2025年1月31日をもってサービスを終了しました。</p>
                </div>
                <div v-else-if="additionalLogiSetting.systemName === 'salmonAcross'" class="warehouse-item-content">
                  <p class="text-size-20 font-bold text-danger">本サービスは、2026年5月31日をもってサービスを終了しました。</p>
                </div>
                <div v-else class="warehouse-item-content">
                  <div class="left-item-content">
                    <div>
                      <button type="button" class="btn w-150 button-additional-warehouse mr-b-10 btn-info" @click.prevent="openAdditionalWarehouseModal(additionalLogiSetting)">追加する</button>
                    </div>
                  </div>
                  <div class="right-item-content">
                    <div class="logi-sumary" v-html="replaceHTMLSellerInfo(additionalLogiSetting.summary)" />
                  </div>
                </div>
              </div>
              <div v-if="additionalLogiSetting.systemName === 'salmonYamato' || additionalLogiSetting.systemName === 'salmonAcross' || additionalLogiSetting.systemName === 'salmonSc' && userInfo.scWarehouseUse === '9'" class="col-md-3 right-item">
                <a href="javascript:void(0)" @click.prevent="openUsagePlanManagement(additionalLogiSetting.systemName)" class="link-manage-plan">費用明細</a>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div v-if="!initial && !additionalLogiSettings.length" class="pd-t-10 pd-l-45">
            追加可能な倉庫はありません
          </div>
        </template>
      </div>
    </div>
    <additional-warehouse-modal
      v-if="isShowAdditionalWarehouseModal"
      :logiSetting="selectedAdditionalLogiSetting"
      @close="closeAdditionalWarehouseModal"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import AdditionalWarehouseModal from '@/view/warehouses/AdditionalWarehouseModal'
import WarehouseService from '@/services/warehouseservice'
import WarehouseAcrossService from '@/services/warehouseacrossservice'
import LoadingBlock from '@/components/LoadingBlock'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'
import UpgradePlanModal from '@/view/warehouses/UpgradePlanModal'
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  components: {
    AdditionalWarehouseModal,
    LoadingBlock,
    UpgradePlanModal
  },
  data () {
    return {
      isShowAdditionalWarehouseModal: false,
      loader: null,
      usingLogiSettings: [],
      additionalLogiSettings: [],
      initial: true,
      selectedAdditionalLogiSetting: null
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    openAdditionalWarehouseModalByHome (systemName) {
      const logiSettings = [...this.usingLogiSettings, ...this.additionalLogiSettings]
      const logiSetting = logiSettings.find((item) => { return item.systemName === systemName })
      if (logiSetting) {
        if (logiSetting.systemName === 'salmonAcross' && this.userInfo.acrossAgreeFlg === '1') {
          return false
        }

        if (logiSetting.systemName === 'salmonSc' && this.userInfo.scWarehouseUse === '1') {
          return false
        }

        this.openAdditionalWarehouseModal(logiSetting)
      }
    },
    openUsagePlanManagement (systemName) {
      let url = '/delivery-requests/expense-detail-actual-shipment'
      if (systemName === 'salmonSc') {
        url = '/warehouse-sc/expense-details/shipment-record'
      }
      if (systemName === 'salmonAcross') {
        url = '/warehouse-across/expense-details/shipment-record'
      }
      this.$router.push(url)
    },
    openWarehouseManagement (logiSetting) {
      let logParams = {
        name: eventCode.warehouses.open_warehouse_management_button,
        properties: {
          seq: logiSetting.seq,
          logiName: logiSetting.logiName
        }
      }
      EventService.postTrackLog(logParams)

      if (logiSetting.systemName === 'salmonAcross') {
        this.loader = this.$loading.show()
        WarehouseAcrossService.getMaintenanceMode()
          .then((response) => {
            if (response.data.maintenance) {
              this.$store.commit('toggleMaintenanceModal', {
                show: true
              })
            } else {
              if (this.userInfo.acrossAgreeFlg === '0') {
                this.openAdditionalWarehouseModal(logiSetting)
                return false
              } else {
                warehouseManagementUrl = '/warehouse-across/top'
                this.$router.push(warehouseManagementUrl)
              }
            }
          })
          .catch((error) => {
            this.$store.commit('toggleModal', {
              show: true,
              message: error
            })
          })
          .finally(() => {
            this.loader && this.loader.hide()
          })
        return false
      }

      let warehouseManagementUrl = '/warehouse-sc/top'
      if (logiSetting.systemName === 'Amazon') {
        warehouseManagementUrl = '/warehouse-amazon/top'
      }

      this.$router.push(warehouseManagementUrl)
    },
    closeAdditionalWarehouseModal () {
      $('#additional-warehouse-modal').modal('hide')
      this.isShowAdditionalWarehouseModal = false
      this.selectedAdditionalLogiSetting = null
    },
    openAdditionalWarehouseModal (additionalLogiSetting) {
      this.isShowAdditionalWarehouseModal = true
      this.selectedAdditionalLogiSetting = additionalLogiSetting

      let logParams = {
        name: eventCode.warehouses.addtional_modal.show,
        properties: {
          seq: additionalLogiSetting.seq,
          logiName: additionalLogiSetting.logiName
        }
      }
      EventService.postTrackLog(logParams)
    },
    async getWarehouses () {
      this.loader = this.$loading.show()
      await WarehouseService.getWarehouses()
        .then(response => {
          this.usingLogiSettings = response.data.using
          this.additionalLogiSettings = response.data.additional.filter((item) => item.systemName !== 'salmonYamato')
          if (this.initial) {
            this.initial = false
          }
          this.loader && this.loader.hide()
        })
        .catch(error => {
          this.loader && this.loader.hide()
          this.$store.commit('toggleModal', {
            show: true,
            message: error
          })
        })
    },
    trackLogScreen () {
      let logParams = {
        name: eventCode.warehouses.screen_top,
        properties: {}
      }
      EventService.postTrackLog(logParams)
    },
    embbedAllSlickJs () {
      const slick = document.createElement('script')
      slick.setAttribute('id', 'warehouse-slick')
      slick.setAttribute('src', '/static/dists/js/slick.js')
      document.head.appendChild(slick)

      const slickSalmon = document.createElement('script')
      slickSalmon.setAttribute('id', 'warehouse-slick-salmon')
      slickSalmon.setAttribute('src', '/static/dists/js/slick-salmon.js')
      document.head.appendChild(slickSalmon)
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    }),
    isMaintenance () {
      return this.userInfo.maintenanceFlg
    }
  },
  async mounted () {
    await this.getWarehouses()

    this.trackLogScreen()
    this.embbedAllSlickJs()
    if (this.$route.query && this.$route.query.name) {
      this.openAdditionalWarehouseModalByHome(this.$route.query.name)
    }
  },
  beforeDestroy () {
    let scriptSlickSelector = $('#warehouse-slick')
    let scriptSlickSalmonSelector = $('#warehouse-slick-salmon')
    scriptSlickSelector.remove()
    scriptSlickSalmonSelector.remove()
  }
}
</script>
<style scoped>
@media (min-width: 992px) {
  .col-md-8 {
      width: 80%;
  }
  .col-md-4 {
    width: 20%;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/warehouses/Warehouses.vue